import { networkService } from "services/networkService";
import {
  METHOD_OBJECT_STORAGE_ANSIBLE_LIST,
  METHOD_OBJECT_STORAGE_ANSIBLE_CREATE,
  METHOD_OBJECT_STORAGE_ANSIBLE_UPDATE,
  METHOD_OBJECT_STORAGE_ANSIBLE_DELETE,
  METHOD_OBJECT_STORAGE_ANSIBLE_DETAIL,

  METHOD_VSP_ONE_OBJECT_VERSION_LIST,
  METHOD_VSP_ONE_OBJECT_VERSION_CREATE,
  METHOD_VSP_ONE_OBJECT_VERSION_UPDATE,
  METHOD_VSP_ONE_OBJECT_VERSION_DELETE,
  METHOD_VSP_ONE_OBJECT_VERSION_DETAIL,

} from "constants/admin/masters/ansibleObject";


class ansibleObjectServices {

  //Object Storage Ansible Module METHODS
  getAllObjectStorageAnsible = (data) => {
    return networkService
      .post(METHOD_OBJECT_STORAGE_ANSIBLE_LIST, data)
      .then((response) => response.data);
  };
  getObjectStorageAnsibleDetail = (id) => {
    const updatedMethodName = METHOD_OBJECT_STORAGE_ANSIBLE_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createObjectStorageAnsible = (data) => {
    return networkService
      .post(METHOD_OBJECT_STORAGE_ANSIBLE_CREATE, data)
      .then((response) => response.data);
  };
  updateObjectStorageAnsible = (data, id) => {
    const updatedMethodName = METHOD_OBJECT_STORAGE_ANSIBLE_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteObjectStorageAnsible = (id, is_delete = false) => {
    const updatedMethodName = METHOD_OBJECT_STORAGE_ANSIBLE_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName, { data: { is_delete } })
      .then((response) => response.data);
  };

  //VSP One Object Version METHODS
  getAllVSPOneObjectVersion = (data) => {
    return networkService
      .post(METHOD_VSP_ONE_OBJECT_VERSION_LIST, data)
      .then((response) => response.data);
  };
  getVSPOneObjectVersionDetail = (id) => {
    const updatedMethodName = METHOD_VSP_ONE_OBJECT_VERSION_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createVSPOneObjectVersion = (data) => {
    return networkService
      .post(METHOD_VSP_ONE_OBJECT_VERSION_CREATE, data)
      .then((response) => response.data);
  };
  updateVSPOneObjectVersion = (data, id) => {
    const updatedMethodName = METHOD_VSP_ONE_OBJECT_VERSION_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteVSPOneObjectVersion = (id, is_delete = false) => {
    const updatedMethodName = METHOD_VSP_ONE_OBJECT_VERSION_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName, { data: { is_delete } })
      .then((response) => response.data);
  };

}
export default ansibleObjectServices;